import React from "react";

import { AccountIcon } from "./AccountIcon";
import { ArrowForward } from "./ArrowForward";
import { ArrowIcon } from "./ArrowIcon";
import { BookmarkAdd } from "./BookmarkAdd";
import { CalculatedSummaryIcon } from "./CalculatedSummaryIcon";
import { Close } from "./Close";
import { ConfirmationQuestionIcon } from "./ConfirmationQuestionIcon";
import { ContentCopyIcon } from "./ContentCopyIcon";
import { DeleteIcon } from "./DeleteIcon";
import { Download } from "./Download";
import { FolderIcon } from "./FolderIcon";
import { Help } from "./Help";
import { Header2 } from "./Header2";
import { SectionIcon } from "./SectionIcon";
import { Link } from "./Link";
import { BoldIcon } from "./BoldIcon";
import { DatabaseIcon } from "./DatabaseIcon";
import { FunctionIcon } from "./FunctionIcon";
import { HighlightIcon } from "./HighlightIcon";
import { ListBulletedIcon } from "./ListBulletedIcon";
import { TextSnippetIcon } from "./TextSnippetIcon";
import { ListCollectorIcon } from "./ListCollectorIcon";
import { LoadingIcon } from "./LoadingIcon";
import { MoveDown } from "./MoveDown";
import { MoveUp } from "./MoveUp";
import { NextArrow } from "./PaginationIcons/NextArrow";
import { OpenInNew } from "./OpenInNew";
import { PreviousArrow } from "./PaginationIcons/PreviousArrow";
import { Search } from "./Search";
import { SignOutLogo } from "./SignOutLogo";
import { Star } from "./Star";
import { StarFilled } from "./StarFilled";
import { SuccessTickIcon } from "./SuccessTickIcon";
import { SwapVert } from "./SwapVert";

export { OnsLargeLogo } from "./Logos/OnsLargeLogo";
export { OnsSmallLogo } from "./Logos/OnsSmallLogo";
export { SignOutLogo } from "./SignOutLogo";
export { AccountIcon } from "./AccountIcon";
export { ArrowIcon } from "./ArrowIcon";
export { SuccessTickIcon } from "./SuccessTickIcon";
export { LoadingIcon } from "./LoadingIcon";
export { NextArrow } from "./PaginationIcons/NextArrow";
export { PreviousArrow } from "./PaginationIcons/PreviousArrow";
export { Star } from "./Star";
export { StarFilled } from "./StarFilled";
export { BookmarkAdd } from "./BookmarkAdd";
export { OpenInNew } from "./OpenInNew";
export { Close } from "./Close";
export { ArrowForward } from "./ArrowForward";
export { Help } from "./Help";
export { Link } from "./Link";
export { CalculatedSummaryIcon } from "./CalculatedSummaryIcon";
export { ConfirmationQuestionIcon } from "./ConfirmationQuestionIcon";
export { ContentCopyIcon } from "./ContentCopyIcon";
export { DatabaseIcon } from "./DatabaseIcon";
export { DeleteIcon } from "./DeleteIcon";
export { Download } from "./Download";
export { FolderIcon } from "./FolderIcon";
export { BoldIcon } from "./BoldIcon";
export { HighlightIcon } from "./HighlightIcon";
export { ListBulletedIcon } from "./ListBulletedIcon";
export { FunctionIcon } from "./FunctionIcon";
export { ListCollectorIcon } from "./ListCollectorIcon";
export { Search } from "./Search";
export { SectionIcon } from "./SectionIcon";
export { SwapVert } from "./SwapVert";
export { MoveDown } from "./MoveDown";
export { MoveUp } from "./MoveUp";
export { Header2 } from "./Header2";
export { TextSnippetIcon } from "./TextSnippetIcon";

import { CheckboxIcon } from "./AnswerTypes/Checkbox";
import { Currency } from "./AnswerTypes/Currency";
import { Date } from "./AnswerTypes/Date";
import { DateRange } from "./AnswerTypes/DateRange";
import { Duration } from "./AnswerTypes/Duration";
import { MutuallyExclusive } from "./AnswerTypes/MutuallyExclusive";
import { Number } from "./AnswerTypes/Number";
import { Percentage } from "./AnswerTypes/Percentage";
import { Radio } from "./AnswerTypes/Radio";
import { SelectIcon } from "./AnswerTypes/Select";
import { Text } from "./AnswerTypes/Text";
import { Textarea } from "./AnswerTypes/Textarea";
import { Unit } from "./AnswerTypes/Unit";
export { CheckboxIcon } from "./AnswerTypes/Checkbox";
export { Currency } from "./AnswerTypes/Currency";
export { Date } from "./AnswerTypes/Date";
export { DateRange } from "./AnswerTypes/DateRange";
export { Duration } from "./AnswerTypes/Duration";
export { MutuallyExclusive } from "./AnswerTypes/MutuallyExclusive";
export { Number } from "./AnswerTypes/Number";
export { Percentage } from "./AnswerTypes/Percentage";
export { Radio } from "./AnswerTypes/Radio";
export { SelectIcon } from "./AnswerTypes/Select";
export { Text } from "./AnswerTypes/Text";
export { Textarea } from "./AnswerTypes/Textarea";
export { Unit } from "./AnswerTypes/Unit";

export type IconTypes =
  | "AccountIcon"
  | "ArrowForward"
  | "ArrowIcon"
  | "BookmarkAdd"
  | "CalculatedSummaryIcon"
  | "CheckboxIcon"
  | "Close"
  | "ConfirmationQuestionIcon"
  | "ContentCopyIcon"
  | "Currency"
  | "Date"
  | "DateRange"
  | "BoldIcon"
  | "DatabaseIcon"
  | "DeleteIcon"
  | "Download"
  | "Duration"
  | "FolderIcon"
  | "FunctionIcon"
  | "HighlightIcon"
  | "ListBulletedIcon"
  | "Help"
  | "Header2"
  | "Link"
  | "ListCollectorIcon"
  | "LoadingIcon"
  | "MoveDown"
  | "MoveUp"
  | "MutuallyExclusive"
  | "NextArrow"
  | "Number"
  | "OpenInNew"
  | "Percentage"
  | "PreviousArrow"
  | "Radio"
  | "Search"
  | "SectionIcon"
  | "SelectIcon"
  | "SignOutLogo"
  | "Star"
  | "StarFilled"
  | "SuccessTickIcon"
  | "SwapVert"
  | "TextSnippetIcon"
  | "Text"
  | "Textarea"
  | "Unit";
export interface Props {
  iconType: IconTypes;
  classes?: string;
  style?: React.CSSProperties;
}

export const SelectedIcon = (props: Props) => {
  switch (props.iconType) {
    case "AccountIcon":
      return <AccountIcon classes={props.classes} />;
    case "ArrowForward":
      return <ArrowForward classes={props.classes} />;
    case "ArrowIcon":
      return <ArrowIcon classes={props.classes} style={props.style} />;
    case "BookmarkAdd":
      return <BookmarkAdd classes={props.classes} />;
    case "CalculatedSummaryIcon":
      return <CalculatedSummaryIcon classes={props.classes} />;
    case "CheckboxIcon":
      return <CheckboxIcon classes={props.classes} />;
    case "Close":
      return <Close classes={props.classes} />;
    case "ConfirmationQuestionIcon":
      return <ConfirmationQuestionIcon classes={props.classes} />;
    case "ContentCopyIcon":
      return <ContentCopyIcon classes={props.classes} />;
    case "Currency":
      return <Currency classes={props.classes} />;
    case "Date":
      return <Date classes={props.classes} />;
    case "DateRange":
      return <DateRange classes={props.classes} />;
    case "DatabaseIcon":
      return <DatabaseIcon classes={props.classes} />;
    case "DeleteIcon":
      return <DeleteIcon classes={props.classes} />;
    case "Download":
      return <Download classes={props.classes} />;
    case "Duration":
      return <Duration classes={props.classes} />;
    case "FolderIcon":
      return <FolderIcon classes={props.classes} />;
    case "BoldIcon":
      return <BoldIcon classes={props.classes} />;
    case "FunctionIcon":
      return <FunctionIcon classes={props.classes} />;
    case "Header2":
      return <Header2 classes={props.classes} />;
    case "Help":
      return <Help classes={props.classes} />;
    case "HighlightIcon":
      return <HighlightIcon classes={props.classes} />;
    case "Link":
      return <Link classes={props.classes} />;
    case "ListBulletedIcon":
      return <ListBulletedIcon classes={props.classes} />;
    case "ListCollectorIcon":
      return <ListCollectorIcon classes={props.classes} />;
    case "LoadingIcon":
      return <LoadingIcon classes={props.classes} />;
    case "MoveDown":
      return <MoveDown classes={props.classes} />;
    case "MoveUp":
      return <MoveUp classes={props.classes} />;
    case "MutuallyExclusive":
      return <MutuallyExclusive classes={props.classes} />;
    case "NextArrow":
      return <NextArrow classes={props.classes} />;
    case "Number":
      return <Number classes={props.classes} />;
    case "OpenInNew":
      return <OpenInNew classes={props.classes} />;
    case "Percentage":
      return <Percentage classes={props.classes} />;
    case "PreviousArrow":
      return <PreviousArrow classes={props.classes} />;
    case "Radio":
      return <Radio classes={props.classes} />;
    case "Search":
      return <Search classes={props.classes} />;
    case "SectionIcon":
      return <SectionIcon classes={props.classes} />;
    case "SelectIcon":
      return <SelectIcon classes={props.classes} />;
    case "SignOutLogo":
      return <SignOutLogo classes={props.classes} />;
    case "Star":
      return <Star classes={props.classes} />;
    case "StarFilled":
      return <StarFilled classes={props.classes} />;
    case "SuccessTickIcon":
      return <SuccessTickIcon classes={props.classes} />;
    case "SwapVert":
      return <SwapVert classes={props.classes} />;
    case "TextSnippetIcon":
      return <TextSnippetIcon classes={props.classes} />;
    case "Text":
      return <Text classes={props.classes} />;
    case "Textarea":
      return <Textarea classes={props.classes} />;
    case "Unit":
      return <Unit classes={props.classes} />;
    default:
      return null;
  }
};
